const apptStatus = {
  registered: {
    title: "Registration Complete",
    message:
      "Your COVID-19 reservation has been confirmed! Once an appointment has been assigned to you, you must confirm or you'll be placed back on the waitlist.",
  },
  unavailable: {
    title: "Timeslot Unavailable",
    message: "This appointment timeslot is no longer available.",
    textAlign: "text-sm-center",
  },
  waitlisted: {
    title: "Waitlisted",
    message:
      "Thank you, we will keep you on the waitlist and contact you as soon as possible with another available time slot.",
  },
  reserved: {
    title: "Appointment Time Reserved",
    message:
      "Thank you for confirming. Your timeslot has been reserved. You should be receiving an AxS Link momentarily.",
  },
  cancelled: {
    title: "Appointment Cancelled",
    message: "Your COVID-19 appointment has been cancelled.",
    textAlign: "text-sm-center",
  },
};

export default apptStatus;
